import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/sites/sites.service';
import { UsersService } from 'src/app/users/users.service';
import { UtilizationSettings } from '../site-utilization-settings/site-utilization-settings.interface';
import { Subscription } from 'rxjs';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
	selector: 'site-settings-page',
	templateUrl: './site-settings-page.component.html',
	styleUrls: ['./site-settings-page.component.css']
})
export class SiteSettingsPage implements OnInit, OnDestroy {
	@ViewChild('siteSettings', { static: true }) siteSettings!: TemplateRef<any>;
	@ViewChild('chargerUtilizationSettings', { static: true }) chargerUtilizationSettings!: TemplateRef<any>;
	@ViewChild('truckUtilizationSettings', { static: true }) truckUtilizationSettings!: TemplateRef<any>
	@ViewChild('batteryUtilizationSettings', { static: true }) batteryUtilizationSettings!: TemplateRef<any>
	@ViewChild('brmSiteSettings', { static: true }) brmSiteSettings!: TemplateRef<any>;
	@ViewChild('energySiteSettings', { static: true }) energySiteSettings!: TemplateRef<any>;
		// Add more tabs as needed

	tabs: Record<string, TemplateRef<any>> = {};
	activeTab!: TemplateRef<any>;
	currentUser: any;
	siteId?: number;
	siteUtilizationSettings?: UtilizationSettings;

	isPSDevicesSite: boolean = false;

	siteSub: Subscription = new Subscription();

	siteHasDevices: boolean = false;
	siteHasIotahDevices: boolean = false;
	siteHasCharglinkDevices: boolean = false;
	siteHasBRMDevices: boolean = false;
	siteHasBattlinkDevices: boolean = false;
	siteHasIMDevices: boolean = false;
	siteHasStudies: boolean = false;

	constructor (
		public usersService: UsersService,
		private siteService: SitesService,
		private route: ActivatedRoute,
		private sideMenuService: SideMenuService,
		private commonService: CommonService,
	) { }

	ngOnInit(): void {
		// Initialize tabs with TemplateRefs
		this.currentUser = this.usersService.getCurrentUser();
		this.siteId = Number(this.route.parent?.snapshot.params.siteId);
		this.tabs = {
			siteSettings: this.siteSettings,
			chargerUtilizationSettings: this.chargerUtilizationSettings,
			truckUtilizationSettings: this.truckUtilizationSettings,
			batteryUtilizationSettings: this.batteryUtilizationSettings,
			brmSiteSettings: this.brmSiteSettings,
			energySiteSettings: this.energySiteSettings,
		};

		this.activeTab = this.tabs.siteSettings;
		this.getSiteUtilizationSettings();

		this.siteSub = this.sideMenuService.currentSite.subscribe((siteInfo:any) => {
			this.siteHasIotahDevices = (+siteInfo.iotah_devices_count) > 0;
			this.siteHasCharglinkDevices = (+siteInfo.chargLink_devices_count) > 0;
			this.siteHasBattlinkDevices = (+siteInfo.battlink_devices_count + +siteInfo.lithium_battlink_devices_count + +siteInfo.battlink_ii_devices_count) > 0;
			this.siteHasIMDevices = (+siteInfo.im_devices_count) > 0;
			this.siteHasBRMDevices = (+siteInfo.brm_devices_count) > 0;
			this.siteHasStudies = (+siteInfo.studies_count) > 0;

			this.siteHasDevices = this.siteHasIotahDevices ||
				this.siteHasCharglinkDevices ||
				this.siteHasBattlinkDevices ||
				this.siteHasIMDevices ||
				this.siteHasBRMDevices;

			this.isPSDevicesSite = siteInfo?.name == this.commonService.powerStudiesDevicesSiteName;
		});
	}

	setActiveTable(tab: TemplateRef<any>) {
		this.activeTab = tab;
	}

	getSiteUtilizationSettings() {
		if (!this.siteId)
			return;

		this.siteService.getSiteUtilizationSettings(this.siteId).subscribe((res: any) => {
			const siteUtilizationData = res && res.length ? res[0] : {};
			return this.siteService.setUtilizationSettingsCurrentSite(siteUtilizationData);
		});
	}

	ngOnDestroy() {
		this.siteSub.unsubscribe();
	}
}
